var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4198_5141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3253 31.5753V18.4455C14.3253 18.1748 14.5467 17.9531 14.8177 17.9531H18.3722C18.6429 17.9531 18.8646 18.1748 18.8646 18.4455V31.5753C18.8646 31.846 18.6429 32.0677 18.3722 32.0677H14.8177C14.547 32.0677 14.3253 31.846 14.3253 31.5753Z",
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1294 31.5753V21.6158C21.1294 21.3451 21.351 21.1234 21.6218 21.1234H25.1763C25.447 21.1234 25.6687 21.3451 25.6687 21.6158V31.5753C25.6687 31.846 25.447 32.0677 25.1763 32.0677H21.6218C21.3508 32.0677 21.1294 31.846 21.1294 31.5753Z",
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52186 31.5753V14.261C7.52186 13.9902 7.74329 13.7686 8.01427 13.7686L11.5685 13.7688C11.8393 13.7688 12.0609 13.9904 12.0609 14.2612V31.5755C12.0609 31.8462 11.8393 32.0679 11.5685 32.0679L8.01404 32.0677C7.74328 32.0677 7.52186 31.846 7.52186 31.5753Z",
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9374 31.5753V24.0233C27.9374 23.7525 28.159 23.5309 28.4298 23.5309H31.9842C32.255 23.5309 32.4767 23.7525 32.4767 24.0233V31.5753C32.4767 31.846 32.255 32.0677 31.9842 32.0677H28.4298C28.159 32.0677 27.9374 31.846 27.9374 31.5753Z",
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7505 34.3913C35.7505 34.6669 35.5288 34.8837 35.2581 34.8837H4.73521C4.46445 34.8837 4.2428 34.6672 4.2428 34.3913L4.24302 5.63526C4.24302 5.3596 4.46467 5.14285 4.73543 5.14285C5.00619 5.14285 5.22784 5.35937 5.22784 5.63526V33.8987H35.2587C35.5292 33.8987 35.7507 34.1203 35.7507 34.3911L35.7505 34.3913Z",
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3087 11.7833H27.2264L24.8329 6.03814C25.453 5.84327 26.1119 5.73724 26.7956 5.73724C30.2345 5.73724 33.0556 8.40799 33.3088 11.783L33.3087 11.7833ZM25.2756 13.0946L22.722 7.16551C23.0909 6.87154 23.4934 6.61975 23.9208 6.40991L26.2849 12.0849L25.2756 13.0946ZM21.9591 7.88351L24.526 13.8435L23.5227 14.8466L21.1091 9.04608C21.349 8.62666 21.6354 8.23825 21.9591 7.88311V7.88351ZM20.2477 12.2757C20.2477 11.5826 20.3584 10.9152 20.5593 10.288L22.7698 15.6002L21.8368 16.5333C20.8491 15.388 20.2477 13.902 20.2477 12.2757ZM26.7957 18.8134C25.1678 18.8134 23.6801 18.2136 22.5334 17.2284L26.9945 12.7677H33.3088C33.0555 16.1431 30.2345 18.8134 26.7957 18.8134Z",
    fill: "#10B981"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4198_5141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.705fe766abcc6b7b53ce85311d5338f3.svg";
export { ForwardRef as ReactComponent };